import { cssVars } from "@faire/slate/lib/cssVars";
import React from "react";
import {
  cssTransition,
  Bounce,
  ToastContainer as ToastifyContainer,
  ToastContainerProps,
} from "react-toastify";

import { TOAST_CONTAINER_DESKTOP_ID, TOAST_CONTAINER_MOBILE_ID } from "./const";

interface IProps {
  /**
   * **web**
   * The css top position of the toast container.
   */
  top?: string;

  // DO NOT ADD any new prop without aligning with Slate team first
}

/**
 * The container for rendering toasts.
 */
export const ToastContainer = ({ top }: IProps) => {
  const style = containerVars({ top });
  return (
    <>
      <ToastifyContainer
        {...commonProps}
        className="fs-toast-container hidden! md:flex!"
        style={style}
        transition={Bounce}
        position="top-right"
        containerId={TOAST_CONTAINER_DESKTOP_ID}
      />
      <ToastifyContainer
        className="fs-toast-container flex md:hidden!"
        {...commonProps}
        transition={Slide}
        position="bottom-center"
        containerId={TOAST_CONTAINER_MOBILE_ID}
      />
    </>
  );
};

const commonProps: ToastContainerProps = {
  draggable: true,
  closeButton: false,
  hideProgressBar: false,
  newestOnTop: true,
  "aria-label": undefined,
};

const Slide = cssTransition({
  enter: "Toastify__slide-enter--bottom-center",
  exit: "Toastify__slide-exit--bottom-center",
  collapse: false,
  collapseDuration: 0,
  appendPosition: false,
});

const containerVars = cssVars({
  vars: {
    top: "toastify-toast-top",
  },
});
